// extracted by mini-css-extract-plugin
export default {"board":"a56b9ffa1846048688c9","status":"a44a59da410962190406","gameboard":"d1d2b8b71cfa26eb0ea3"};